import { addDays } from "date-fns";
import { formatInTimeZone, fromZonedTime } from "date-fns-tz";

import { env } from "@/config/env";

const zone = env.appointmentCalendarZone;

/**
 * Calendar `yyyy-MM-dd` in the same zone as appointment-service
 * (`chikitsalink.appointment.zone`), so slot APIs never send “today” that the
 * server treats as yesterday.
 */
export function ymdTodayInAppointmentZone(now = new Date()): string {
  return formatInTimeZone(now, zone, "yyyy-MM-dd");
}

/**
 * ISO-8601 weekday in the appointment zone: 1 = Monday … 7 = Sunday.
 * Matches `java.time.DayOfWeek#getValue()` used when generating slots.
 */
export function isoWeekdayInAppointmentZone(now = new Date()): number {
  return Number(formatInTimeZone(now, zone, "i"));
}

export function ymdAddDaysInAppointmentZone(ymd: string, days: number): string {
  // Interpret `ymd` as a calendar day at noon in the appointment zone (never
  // via `new Date(y,m,d)` in the browser's local TZ, which skews quick dates).
  const anchor = fromZonedTime(`${ymd}T12:00:00`, zone);
  return formatInTimeZone(addDays(anchor, days), zone, "yyyy-MM-dd");
}

export function appointmentZoneQuickDates(
  count: number,
  now = new Date(),
): string[] {
  const start = ymdTodayInAppointmentZone(now);
  return Array.from({ length: count }, (_, i) =>
    ymdAddDaysInAppointmentZone(start, i),
  );
}
